export const ApiRoutes = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  REFRESH: '/auth/refresh',
  PASSWORD_RESET_REQUEST: '/auth/password-reset/request',
  PASSWORD_RESET_VALIDATE: '/auth/password-reset/validate-token',
  PASSWORD_RESET_CONFIRM: '/auth/password-reset/confirm',
  ACTIVATION_REQUEST: '/auth/activation/request',
  ACTIVATION_VALIDATE: '/auth/activation/validate-token',
  ACTIVATION_CONFIRM: '/auth/activation/confirm',
  USERS: '/users',
  USERS_ME: '/users/me',
  USERS_ME_PASSWORD: '/users/me/password',
  USER_BY_ID: (userId: string) => `/users/${userId}`,
  USER_OPTIONS: '/users/options',
  USER_ROLE_ASSIGNMENTS: '/users/role-assignments',
  USER_BLOCK: (userId: string) => `/users/${userId}/block`,
  USER_UNBLOCK: (userId: string) => `/users/${userId}/unblock`,
  USER_INACTIVATE: (userId: string) => `/users/${userId}/inactivate`,
  USER_REACTIVATE: (userId: string) => `/users/${userId}/reactivate`,
  EXTERNAL_USERS: '/external-users',
  EXTERNAL_USER_BY_ID: (userId: string) => `/external-users/${userId}`,
  INTERNAL_USERS: '/internal-users',
  INTERNAL_USER_BY_ID: (userId: string) => `/internal-users/${userId}`,
  ROLE_ASSIGNMENTS: '/users/role-assignments',
  ROLE_REMOVALS: '/users/role-removals',
  ROLES: '/roles',
  ROLE_BY_ID: (roleId: string) => `/roles/${roleId}`,
  PERMISSIONS: '/permissions',
} as const

const AUTH_PUBLIC_ROUTES = new Set<string>([
  ApiRoutes.LOGIN,
  ApiRoutes.REFRESH,
  ApiRoutes.LOGOUT,
  ApiRoutes.PASSWORD_RESET_REQUEST,
  ApiRoutes.PASSWORD_RESET_VALIDATE,
  ApiRoutes.PASSWORD_RESET_CONFIRM,
  ApiRoutes.ACTIVATION_REQUEST,
  ApiRoutes.ACTIVATION_VALIDATE,
  ApiRoutes.ACTIVATION_CONFIRM,
])

export function isAuthRoute(url: string | undefined): boolean {
  if (!url) return false
  for (const route of AUTH_PUBLIC_ROUTES) {
    if (url.endsWith(route)) return true
  }
  return url.includes('/auth/')
}
